import axios from 'axios'
import { getHeaders } from '@/tools/utils.js'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

const prefix = '/profiles'

export default {

  async list () {
    const headers = await getHeaders()
    return axios.get(prefix, { headers })
  },

  async create (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/create', criterias, { headers })
  },

  async edit (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/update', criterias, { headers })
  },

  async delete (criterias) {
    const headers = await getHeaders()
    return axios.post(prefix + '/delete', criterias, { headers })
  }
}
